export default __webpack_public_path__ + "static/Economic Model Update - English-2d59a5ba771bb85e33f0723f0945c7be.pdf";